<path
    d="M12.2047 6.96611L17.9257 7.42509L13.5662 11.1588L14.8984 16.7415L10.0001 13.75L5.10181 16.7415L6.434 11.1588L2.07446 7.42509L7.79549 6.96611L10.0001 1.66663L12.2047 6.96611ZM8.65649 8.151L5.17017 8.43014L7.82642 10.7063L7.01506 14.108L10.0001 12.2851L12.9843 14.108L12.1737 10.7063L14.8292 8.43014L11.3437 8.151L10.0001 4.92102L8.65649 8.151Z"
    fill="currentColor"
/>
